import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DriverRoutingModule } from './driver.routing';
import { AddDriverComponent } from './add-driver/add-driver.component';
import { DriversComponent } from './drivers/drivers.component';
import {NgxPaginationModule} from 'ngx-pagination';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { DriverInfoComponent } from './driver-info/driver-info.component';
import { DriverProfileComponent } from './driver-info/driver-profile/driver-profile.component';
import { DriverHistoryComponent } from './driver-info/driver-history/driver-history.component';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import { DriverFeedbackComponent } from './driver-info/driver-feedback/driver-feedback.component';

@NgModule({
  declarations: [
    AddDriverComponent,
    DriversComponent,
    DriverInfoComponent,
    DriverProfileComponent,
    DriverHistoryComponent,
    DriverFeedbackComponent,

  ],
  imports: [
    CommonModule,
    DriverRoutingModule,
    NgxPaginationModule,
    FormsModule,
    ReactiveFormsModule,
    MatSortModule,
    MatTableModule
  ],
})
export class DriverModule { }
